export function useClientSteps() {
  const { staticUrl } = useRuntimeConfig().public;
  return [
    {
      title: 'Ищем мастера в каталоге',
      subtitle:
        'Выбирай частных мастеров или известные салоны и записывайся прямо из каталога',
      screenImageUrl: `${staticUrl}/landing/step1.png`,
      tips: [
        {
          text: 'Выбирай частных мастеров или известные салоны',
          top: '15%',
          left: '90%',
        },
        {
          text: 'Смотри расписание и записывайся прямо из каталога',
          top: '60%',
          left: '80%',
        },
      ],
    },
    {
      title: 'Фильтр для точного поиска',
      subtitle: 'Записывай близких на приём или вызывай мастера домой',
      screenImageUrl: `${staticUrl}/landing/step2.png`,
      tips: [
        {
          text: 'Фильтры помогут сократить время поиска',
          top: '8%',
          left: '70%',
        },
        {
          text: 'Записывай близких на приём или вызывай мастера домой',
          top: '50%',
          left: '82%',
        },
      ],
    },
    {
      title: 'Выбираем подходящего мастера',
      subtitle: 'Полная информация от стажа до стоимости дополнительных услуг',
      screenImageUrl: `${staticUrl}/landing/step3.png`,
      tips: [
        {
          text: 'Полная информация от стажа до стоимости дополнительных услуг',
          top: '-8%',
          left: '60%',
        },
        {
          text: 'Реальные фото работ с честными отзывами конкретной услуги',
          top: '75%',
          left: '60%',
        },
      ],
    },
    {
      title: 'Записываемся на услугу',
      subtitle: 'В среднем клиенту нужно 27 секунд, чтобы записать на услугу',
      screenImageUrl: `${staticUrl}/landing/step4.png`,
      tips: [
        {
          text: 'В среднем клиенту нужно 27 секунд, чтобы записать на услугу',
          top: '12%',
          left: '60%',
        },
        {
          text: 'График со свободными окнами для записи',
          top: '70%',
          left: '70%',
        },
      ],
    },
    {
      title: 'Получаем уведомление о записи',
      subtitle:
        'Фокусируйся на главном, а мы напомним уведомлением о твоей записи',
      screenImageUrl: `${staticUrl}/landing/step5.png`,
      tips: [
        {
          text: 'Все посещения услуг сохраняются в вашей истории',
          top: '12%',
          left: '70%',
        },
        {
          text: 'Фокусируйся на главном, а мы напомним уведомлением о твоей записи',
          top: '40%',
          left: '65%',
        },
      ],
    },
  ];
}
